// extracted by mini-css-extract-plugin
export default {"wrapper":"TimePill_wrapper__fMjsk","blocked":"TimePill_blocked__oRqaG"};